import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from './stores/auth';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/login',
            name: 'login',
            component: () => import('./views/LoginView.vue'),
            meta: { requiresGuest: true },
        },
        {
            path: '/',
            name: 'dashboard',
            component: () => import('./views/DashboardView.vue'),
            meta: { requiresAuth: true },
        },
        {
            path: '/chat',
            name: 'chat',
            component: () => import('./views/ChatView.vue'),
            meta: { requiresAuth: true },
        },
        {
            path: '/compliance',
            name: 'compliance',
            component: () => import('./views/ComplianceView.vue'),
            meta: { requiresAuth: true },
        },
        {
            path: '/langmd',
            name: 'langmd',
            component: () => import('./views/LangMDView.vue'),
            meta: { requiresAuth: true },
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: '/',
        },
    ],
});

// Navigation guards
router.beforeEach((to, from, next) => {
    const authStore = useAuthStore();

    if (to.meta.requiresAuth && !authStore.isAuthenticated) {
        next('/login');
    } else if (to.meta.requiresGuest && authStore.isAuthenticated) {
        next('/');
    } else {
        next();
    }
});

export default router;
